var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 8.00236C15.9989 12.0439 13.0039 15.3851 9.11323 15.9273C8.74944 15.9778 8.37724 16.0042 7.99944 16.0042C7.56334 16.0042 7.13509 15.9694 6.71805 15.9021C2.90919 15.2887 0 11.985 0 8.00236C0 3.58289 3.58184 0 8 0C12.4182 0 16 3.58289 16 8.00236H15.9989Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24454 3.52905L6.934 8.46324L3.22156 12.4751H4.05732L7.30788 8.96283L9.934 12.4751H12.7776L8.88075 7.26334L12.3365 3.52905H11.5007L8.50743 6.76375L6.08871 3.52905H3.2451H3.24454ZM4.47324 4.14471H5.77929L11.5478 11.8594H10.2417L4.47324 4.14471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.014597a2d3cdad179d12d1dc5c49dfd4.svg";
export { ForwardRef as ReactComponent };